import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { CollapsableTableRow } from './CollapsableTableRow';
import { TwoLinesLayout } from './TwoLinesLayout';

export const LAST_CELL_WIDTH = 60;

export { TableHead, TableBody, CollapsableTableRow, TwoLinesLayout };
